import { Model } from 'miragejs';

/**
 * This model is used by the company search on the register API.
 */
export default Model.extend({});
